import { connect } from 'react-redux';
import ContactDetailsComponent from './ContactDetailsComponent';
import { getDropdownOptions } from '../../../../services/Translation';
import { getCountries } from '../../../../state/reducers/ConfigReducer';
import {
  getData,
  getFormErrors,
  getValidators,
  isRequired,
} from '../../../../state/reducers/ApplicationReducer';
import { getLanguage } from '../../../../state/reducers/AppReducer';
import ApplicationActions from '../../../../state/actions/ApplicationActions';
import { isLAO } from '../../../../state/reducers/LoginReducer';
import { getTargetCountryCode } from '../../../../state/selectors/TargetCountrySelector';

const mapStateToProps = (state) => {
  const data = getData(state);
  const validators = getValidators(state);
  const errors = getFormErrors(state);
  const lang = getLanguage(state);
  const targetCountryCode = getTargetCountryCode(state);

  return {
    isLAO: isLAO(state),
    phoneNumber: data.phonenumber || '',
    phoneNumberError: errors.phonenumber,
    isPhoneNumberRequired: isRequired(validators.phonenumber),
    email: data.applicantEmail || '',
    emailError: errors.applicantEmail,
    isEmailRequired: isRequired(validators.applicantEmail),
    street: data.street || '',
    streetError: errors.street,
    isStreetRequired: isRequired(validators.street),
    city: data.city || '',
    cityError: errors.city,
    isCityRequired: isRequired(validators.city),
    residenceState: data.state || '',
    residenceStateError: errors.state,
    isResidenceStateRequired: isRequired(validators.state),
    postalCode: data.zip || '',
    postalCodeError: errors.zip,
    isPostalCodeRequired: isRequired(validators.zip),
    residenceCountry: data.countryId || null,
    residenceCountryError: errors.countryId,
    isResidenceCountryRequired: isRequired(validators.countryId),
    residenceCountries: getDropdownOptions(getCountries(state), lang),
    fullName: data.ecName || '',
    fullNameError: errors.ecName,
    isFullNameRequired: isRequired(validators.ecName),
    ecPhoneNumber: data.ecPhonenumber || '',
    ecPhoneNumberError: errors.ecPhonenumber,
    isEcPhoneNumberRequired: isRequired(validators.ecPhonenumber),
    ecEmail: data.ecEmail || '',
    ecEmailError: errors.ecEmail,
    isEcEmailRequired: isRequired(validators.ecEmail),
    targetCountryCode,
  };
};

const { formValueChanged } = ApplicationActions;
const mapDispatchToProps = (dispatch) => ({
  phoneNumberChanged: (value) => {
    dispatch(formValueChanged('phonenumber', value));
  },
  emailChanged: (value) => {
    dispatch(formValueChanged('applicantEmail', value));
  },
  streetChanged: (value) => {
    dispatch(formValueChanged('street', value));
  },
  cityChanged: (value) => {
    dispatch(formValueChanged('city', value));
  },
  residenceStateChanged: (value) => {
    dispatch(formValueChanged('state', value));
  },
  postalCodeChanged: (value) => {
    dispatch(formValueChanged('zip', value));
  },
  residenceCountryChanged: (value) => {
    dispatch(formValueChanged('countryId', value));
  },
  fullNameChanged: (value) => {
    dispatch(formValueChanged('ecName', value));
  },
  ecPhoneNumberChanged: (value) => {
    dispatch(formValueChanged('ecPhonenumber', value));
  },
  ecEmailChanged: (value) => {
    dispatch(formValueChanged('ecEmail', value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactDetailsComponent);



// WEBPACK FOOTER //
// ./src/view/forms/Application/ContactDetails/index.js